import React, { Component } from "react";
import { withRouter, Route, Link } from "react-router-dom";
import { connect } from "react-redux";
import { action } from "../../Data";
import { withTranslation, withNamespaces } from "react-i18next";

// components
import Header from "../../Components/Header/header";
import ProductCard from "../../Components/ProductCard";
import LoginComponent from "../../Containers/Authentication";
import InfiniteList from "../../Common/InfiniteList";

// styles
import style from "../../Styles/Containers/Verification.module.css";
import { parseUrlParameter } from "../../Lib/Utils";
import * as Const from "../../Data/const";

class VerificationContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: [1, 1, 1, 1, 1],
      productConfirmList: [],
      user: {},

      UUID: "",

      isLogin: true,
      isLoading: true
    };

    this.init = this.init.bind(this);
    this.handleConfirmDetail = this.handleConfirmDetail.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.handleLoginSuccess = this.handleLoginSuccess.bind(this);
    this.setUUID = this.setUUID.bind(this);

    this.params = {};
  }

  componentDidMount() {
    window.addEventListener("getUUID", this.setUUID);
    this.init();
  }

  getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    let regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return "";
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }

  async init() {
    if (
      window.webkit &&
      window.webkit.messageHandlers &&
      window.webkit.messageHandlers.iosHandler
    ) {
      window.webkit.messageHandlers.iosHandler.postMessage({
        functionName: "getUUID"
      });
    } else {
      await this.setUUID();
    }

    if (!this.props.eSESSION.user) {
      this.setState(
        {
          isLogin: false
        },
        () => {
          return;
        }
      );
    } else {
      this.setState({
        user: this.props.eSESSION.user
      });
    }

    let locale = this.getParameterByName("locale");

    let loginData = this.props.eSESSION.user || {};
    let UUID = this.props.UUID;

    // 아이폰 용은 추후에 작업
    let params = {
      limit: 10,
      ELocale: locale || this.props.COUNTRY_CODE,
      uid: loginData.uid,
      uuid: UUID
    };

    this.setState({
      params: params,
      isLoading: false,
      ELocale: locale || this.props.COUNTRY_CODE
    });
  }

  async setUUID(event) {
    let uuid;

    if (event) {
      uuid = event.detail.uuid;
    } else {
      uuid = await Const.getUUID();
    }

    await this.props.dispatch(action.eSESSION.setUUID(uuid));
  }

  // 인증 디테일
  handleConfirmDetail(item) {
    let queries = { productReleaseCode: item.productReleaseCode };
    this.props.history.push(
      "/user/verification/detail?productReleaseCode=" + item.productReleaseCode
    );
  }

  handleCloseModal() {
    Const.userAppCloseActivity();
  }

  handleLoginSuccess() {
    if (!this.props.eSESSION.user) {
      this.setState(
        {
          isLogin: false
        },
        () => {
          return;
        }
      );
    }

    this.init();
  }

  render() {
    const { t } = this.props;

    let renderListItem = (item, index) => {
      return (
        <ProductCard
          key={index}
          item={item}
          locale={this.state.ELocale}
          handleConfirmDetail={() => this.handleConfirmDetail(item)}
        />
      );
    };

    return (
      <div className={style.container}>
        <Header
          content={t("scan_list")}
          onClosePress={e => {
            Const.userAppCloseActivity();
          }}
        />
        <div className={style.sectionContainer}>
          {/*            {
                this.state.productConfirmList.length > 0 ? renderProductList :
                <div className={style.emptyContainer}>
                  <span className={style.emptyText}>{t('no_authentication')}</span>
                </div>
            }*/}
          {this.state.isLoading ? null : (
            <InfiniteList
              getList={action.eUSER.getProductConfirmMyList}
              listItem={renderListItem}
              params={this.state.params}
            />
          )}
        </div>
        {this.state.isLogin ? null : (
          <LoginComponent
            onRef={ref => {
              this.socialLoginModal = ref;
            }}
            handleClose={this.handleCloseModal}
            loginSuccess={this.handleLoginSuccess}
            modalContents={{ title: t("welcome"), info: t("login_benefit") }}
          />
        )}
      </div>
    );
  }
}

export default connect(state => {
  return {
    eSESSION: state.data.eSESSION.eSESSION,
    COUNTRY_CODE: state.data.eSESSION.COUNTRY_CODE,
    UUID: state.data.eSESSION.UUID
  };
})(withRouter(withTranslation()(VerificationContainer)));
